var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips",style:({
    fontSize: _vm.fontSize + 'px',
    padding: _vm.padding,
    marginBottom: _vm.marginBottom + 'px',
    marginTop: _vm.marginTop + 'px',
    marginLeft: _vm.marginLeft + 'px',
    marginRight: _vm.marginRight + 'px',
    background: _vm.background,
    border: ("1px solid " + _vm.borderColor),
  })},[_c('img',{style:({ width: _vm.iconWidth + 'px', height: _vm.iconHeight + 'px' }),attrs:{"src":_vm.icons[_vm.iconType],"alt":""}}),_c('div',{style:({ color: _vm.color, marginLeft: _vm.left + 'px' })},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }